export const STACK_TASKS_LIMIT = 50;
export const STACK_TASKS_LIMIT_STORAGE_KEY = "stackTasksLimit";
export const STACK_TASKS_PAGINATION_OPTIONS = [10, 25, 50];
